import React from "react";

function Footer() {
  return (
    <>
      <div className="lg:py-6 lg:px-10 py-3 px-5 border-t border-gray-300">
        <h1 className="text-gray-600 lg:text-sm text-[0.6rem]">© Wings. All rights reserved. Developed By JunDemi</h1>
      </div>
    </>
  );
}

export default Footer;
